export type QrPlatform = "wework" | "feishu";

export function isInFeishu(userAgent = navigator.userAgent) {
  const ua = userAgent.toLowerCase();
  return ua.includes("lark") || ua.includes("feishu");
}

export function isInWework(userAgent = navigator.userAgent) {
  const ua = userAgent.toLowerCase();
  return ua.includes("wxwork") && ua.includes("micromessenger");
}

export function getPreferredQrPlatform(
  userAgent = navigator.userAgent
): QrPlatform {
  if (isInWework(userAgent)) {
    return "wework";
  }

  return "feishu";
}

export function getClientAutoLoginPlatform(
  userAgent = navigator.userAgent
): QrPlatform | null {
  if (isInWework(userAgent)) {
    return "wework";
  }

  if (isInFeishu(userAgent)) {
    return "feishu";
  }

  return null;
}
